import { ObjectLiteral } from '~/types/generics';

export enum IReportTypes {
  GET_REPORTS_REQUEST = '@reports/GET_REPORTS_REQUEST',
  GET_REPORTS_SUCCESS = '@reports/GET_REPORTS_SUCCESS',
  GET_REPORTS_FAILURE = '@reports/GET_REPORTS_FAILURE',
  GENERATE_REPORT_REQUEST = '@reports/GENERATE_REPORT_REQUEST',
  GENERATE_REPORT_SUCCESS = '@reports/GENERATE_REPORT_SUCCESS',
  GENERATE_REPORT_FAILURE = '@reports/GENERATE_REPORT_FAILURE',
  GET_GENERATED_REPORTS_REQUEST = '@reports/GET_GENERATED_REPORTS_REQUEST',
  GET_GENERATED_REPORTS_SUCCESS = '@reports/GET_GENERATED_REPORTS_SUCCESS',
  GET_GENERATED_REPORTS_FAILURE = '@reports/GET_GENERATED_REPORTS_FAILURE',
}

export interface IReportFilter {
  id: number;
  reportId: number;
  type: string;
  label: string;
  tag: string;
}

interface IReportProfile {
  id: number;
  reportId: number;
  profileId: number;
}

export interface IReport {
  applicationId: number;
  asynchronous: boolean;
  bizId?: string;
  description: string;
  fileName: string;
  id: number;
  name: string;
  organizationId: number;
  remoteId: number;
  reportDefinition?: string;
  reportFilters: IReportFilter[];
  reportProfiles?: IReportProfile[];
  template?: null;
  type: string;
}

export interface IGeneratedReport {
  applicationId: number;
  creationDate: number;
  customFilters: any;
  filePath: string;
  finishDate: number;
  id: number;
  organizationId: number;
  personId: number;
  report: IReport;
  reportToken: string;
  startDate: number;
  status: string;
}

export interface IGetReportsRequestAction {
  type: typeof IReportTypes.GET_REPORTS_REQUEST;
  payload: {
    params: ObjectLiteral;
  };
}
export interface IGetReportsSuccessAction {
  type: typeof IReportTypes.GET_REPORTS_SUCCESS;
  payload: {
    reports: IReport[];
    totalReports: number;
  };
}
export interface IGetReportsFailureAction {
  type: typeof IReportTypes.GET_REPORTS_FAILURE;
}

export interface IGenerateReportRequestAction {
  type: typeof IReportTypes.GENERATE_REPORT_REQUEST;
  payload: {
    params: ObjectLiteral;
  };
}
export interface IGenerateReportSuccessAction {
  type: typeof IReportTypes.GENERATE_REPORT_SUCCESS;
}
export interface IGenerateReportFailureAction {
  type: typeof IReportTypes.GENERATE_REPORT_FAILURE;
}

export interface IGetGeneratedReportsRequestAction {
  type: typeof IReportTypes.GET_GENERATED_REPORTS_REQUEST;
  payload: {
    id: number;
    params: ObjectLiteral;
  };
}
export interface IGetGeneratedReportsSuccessAction {
  type: typeof IReportTypes.GET_GENERATED_REPORTS_SUCCESS;
  payload: {
    generatedReports: IGeneratedReport[];
    totalGeneratedReports: number;
  };
}
export interface IGetGeneratedReportsFailureAction {
  type: typeof IReportTypes.GET_GENERATED_REPORTS_FAILURE;
}

export type IReportActionsType =
  | IGetReportsRequestAction
  | IGetReportsSuccessAction
  | IGetReportsFailureAction
  | IGenerateReportRequestAction
  | IGenerateReportSuccessAction
  | IGenerateReportFailureAction
  | IGetGeneratedReportsRequestAction
  | IGetGeneratedReportsSuccessAction
  | IGetGeneratedReportsFailureAction;

export interface IReportState {
  readonly loading: boolean;
  readonly reports: IReport[];
  readonly totalReports: number;
  readonly loadingGeneratedReports: boolean;
  readonly generatedReports: IGeneratedReport[];
  readonly totalGeneratedReports: number;
  readonly loadingGenerateReport: boolean;
}
